<template>
  <div :id="'message-' + message.id">
    <div class="clear"></div>
    <my-message-component
      v-on:remove-message="removeMessage($event)"
      v-if="isMine(message.user_id)"
      :message="message"
    ></my-message-component>
    <other-message-component
      v-on:remove-message="removeMessage($event)"
      v-else
      :message="message"
    ></other-message-component>
  </div>
</template>

<script>
import MyMessageComponent from "./MyMessageComponent";
import OtherMessageComponent from "./OtherMessageComponent";
import $ from "jquery";
import { mapState } from "vuex";

export default {
  props: ["message"],
  components: {
    "my-message-component": MyMessageComponent,
    "other-message-component": OtherMessageComponent
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    isMine(senderId) {
      return this.user.id === senderId;
    },
    removeMessage(messageId) {
      if (!confirm("Do you want to delete this message?")) {
        return false;
      }

      this.$http
        .post("/ajax/message/delete/" + messageId, {
          _method: "DELETE"
        })
        .then(response => {
          if (response.data.status === "success") {
            $("#message-" + messageId).hide(500, function() {
              $(this).remove();
            });
          }
        });
    }
  }
};
</script>
<style></style>
